"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorLogAccessLevel_1 = require("../ErrorLogAccessLevel");
var ErrorLogLevel_1 = require("../ErrorLogLevel");
var ErrorLogSignInInfo_1 = require("../ErrorLogSignInInfo");
var ErrorLogType_1 = require("../ErrorLogType");
var zod_1 = require("zod");
var UnknownErrorLog_1 = __importDefault(require("./UnknownErrorLog"));
var ErrorLogBase_1 = __importDefault(require("./ErrorLogBase"));
var FailedDatabaseQueryLog;
(function (FailedDatabaseQueryLog) {
    FailedDatabaseQueryLog.AdditionalInformationSchema = UnknownErrorLog_1.default.AdditionalInformationSchema;
    FailedDatabaseQueryLog.Schema = ErrorLogBase_1.default.Schema.extend({
        type: zod_1.z.literal(ErrorLogType_1.ErrorLogType.Enum.failedDatabaseQuery),
        level: zod_1.z.literal(ErrorLogLevel_1.ErrorLogLevel.Enum.ERROR),
        signInInfo: ErrorLogSignInInfo_1.ErrorLogSignInInfo.Schema,
        additionalInformation: FailedDatabaseQueryLog.AdditionalInformationSchema,
        accessLevel: zod_1.z.literal(ErrorLogAccessLevel_1.ErrorLogAccessLevel.Enum.ADMIN),
    });
})(FailedDatabaseQueryLog || (FailedDatabaseQueryLog = {}));
exports.default = FailedDatabaseQueryLog;
